import type React from 'react';
import { ScreenFrame } from '../screen-frame';
import styles from './placeholder-screen.module.scss';

export interface PlaceholderScreenProps {
  title: string;
  /** Actions under the title, e.g. a sign-out button. */
  children?: React.ReactNode;
  className?: string;
}

/** Holds a route until its screen is built: the title, and any actions, centred in the standard screen frame. */
export const PlaceholderScreen: React.FC<PlaceholderScreenProps> = ({ title, children, className }) => (
  <ScreenFrame className={className}>
    <main className={styles.main}>
      <h1 className={styles.title}>{title}</h1>
      {children ? <div className={styles.actions}>{children}</div> : null}
    </main>
  </ScreenFrame>
);
